'use client';

import Toast from '@/components/Toast/Toast';
import { NotifsContext } from '@/contexts';
import { FC, useCallback, useContext, useEffect, useState } from 'react';
import styles from './styles.module.scss';
const { min } = Math;

const MAX_OFFSET = 75;

const Toaster: FC = () => {
  const { toasts, removeToast } = useContext(NotifsContext);
  const [offsetY, setOffsetY] = useState<number>(
    min(window.scrollY, MAX_OFFSET)
  );

  const closeHandler = (id: string) => {
    removeToast && removeToast(id);
  };

  const updateOffset = useCallback(() => {
    if (window.scrollY > MAX_OFFSET) {
      if (offsetY < MAX_OFFSET) setOffsetY(MAX_OFFSET);
      return;
    }
    setOffsetY(window.scrollY);
  }, []);

  useEffect(() => () => window.removeEventListener('scroll', updateOffset), []);

  useEffect(() => {
    if (toasts.length) {
      window.addEventListener('scroll', updateOffset);
      setOffsetY(min(window.scrollY, MAX_OFFSET));
      return;
    }
    window.removeEventListener('scroll', updateOffset);
  }, [toasts.length]);

  return (
    <div className={styles['container']} style={{ top: `${80 - offsetY}px` }}>
      {toasts.map(({ children, id, toastType, delay }) => (
        <Toast
          toastType={toastType}
          key={id}
          delay={delay}
          onClose={() => closeHandler(id)}
        >
          {children}
        </Toast>
      ))}
    </div>
  );
};

export default Toaster;
